export enum AnnouncementStatus {
  PIN = 'PIN',
  UNPIN = 'UNPIN',
  DRAFT = 'DRAFT',
  PUBLISH = 'PUBLISH',
  UPDATE = 'UPDATE',
  STOP = 'STOP',
}